import { getCustomerDataByNik, getSummaryUnblockCustomer, processSearchUnblockCustomer, processUnblockSubmission, searchCustomerUnblock, startUnblockCustomer } from '../../utils/api';
import { ACTION, FAILED, LOADING, RESET, RESET_ALL, SUCCESS } from './constants';

export function fetchDataCustomerUnblock(params) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'CustomerUnblock';
    try {
      dispatch(loadingAction(true, KEY));
      const { data, meta } = await searchCustomerUnblock(params);
      dispatch(successAction({ ...data, meta }, KEY));
    } catch (error) {
      dispatch(failedAction(error.status, KEY));
      throw error;
    }
  };
}

export function fetchProcessUnblock(params) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'DetailCustomerUnblock';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await startUnblockCustomer(params);
      dispatch(successAction({ ...data }, KEY));
      dispatch(loadingAction(false, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
      throw error;
    }
  };
}

export function fetchHistoryBlock(params) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'HistoryBlock';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await getCustomerDataByNik(params.nationalityId, params.isMask);
      dispatch(successAction(data?.history, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function fetchSummaryUnblockCustomer() {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'Summary';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await getSummaryUnblockCustomer();
      dispatch(successAction(data, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function fetchProcessUnblockSubmission(requestId, payload, callback) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'UnblockSubmission';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await processUnblockSubmission(requestId, payload);
      dispatch(successAction(data, KEY));
      callback({
        success: true
      });
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
      callback({
        success: false,
        message: error.message
      });
    }
  };
}

export function fetchSearchProcessUnblock(payload, callback) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'CustomerUnblock';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await processSearchUnblockCustomer(payload);
      dispatch(successAction(data, KEY));
      callback({
        success: true
      });
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
      callback({
        success: true,
        status: error.status
      });
    }
  };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}

export function setAction(data) {
  return { type: ACTION, data };
}
export function reset(key) {
  return { type: RESET, key };
}
export const clearRedux = (key)  => {
  return async(dispatch) => {
    dispatch(reset(key));
  };
};

export function resetAll() {
  return { type: RESET_ALL };
}
export const clearAllRedux = ()  => {
  return async(dispatch) => {
    dispatch(resetAll());
  };
};
